import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCroatia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1967)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 10.5322 23.736 9.12605 23.2536 7.82612L12 7.30435L0.746391 7.82607C0.264047 9.12605 0 10.5322 0 12C0 13.4679 0.264047 14.874 0.746391 16.1739L12 16.6957L23.2536 16.1739C23.736 14.874 24 13.4679 24 12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1304 8.34787H13.0435L13.3913 5.73913L14.7826 4.69565L16.1739 5.73913V7.8261L15.1304 8.34787Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.86949 8.34787H10.9565L10.6086 5.73913L9.2173 4.69565L7.82605 5.73913V7.8261L8.86949 8.34787Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.3913 8.34787H10.6086V5.73913L12 4.69565L13.3913 5.73913V8.34787Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82605 7.82614V13.5652C7.82605 14.9318 8.48614 16.1471 9.50427 16.9089L10.2347 16.7262L11.1565 17.6534C11.429 17.7096 11.7111 17.7392 12 17.7392C12.2873 17.7392 12.568 17.71 12.8391 17.6544L13.8913 16.7783L14.4956 16.9072C15.5133 16.1454 16.1739 14.9314 16.1739 13.5652V7.82614H7.82605Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82605 7.82611H9.4956V9.49566H7.82605V7.82611Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1652 7.82611H12.8347V9.49566H11.1652V7.82611Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5043 7.82611H16.1738V9.49566H14.5043V7.82611Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.49561 9.49567H11.1652V11.1652H9.49561V9.49567Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8347 9.49567H14.5043V11.1652H12.8347V9.49567Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82605 11.1647H9.4956V12.8343H7.82605V11.1647Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.49561 12.8343H11.1652V14.5038H9.49561V12.8343Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1652 11.1647H12.8347V12.8343H11.1652V11.1647Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5043 11.1647H16.1738V12.8343H14.5043V11.1647Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8347 12.8343H14.5043V14.5038H12.8347V12.8343Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1652 14.5038H12.8347V16.1734H11.1652V14.5038Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.49554 14.504H7.93372C8.07697 15.1246 8.35859 15.6925 8.74475 16.1735H9.49554V14.504Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5043 16.1736H15.255C15.6413 15.6925 15.9228 15.1246 16.0661 14.504H14.5043V16.1736Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.49561 16.1736V16.902C9.98118 17.2674 10.5487 17.5294 11.1652 17.6551V16.1736H9.49561Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8347 16.1736V17.6551C13.4513 17.5295 14.0187 17.2674 14.5043 16.902V16.1736H12.8347Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1967",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgCroatia;
